import { motion } from "framer-motion";
import eth from "../../../../../assets/icons/chains/eth.png";
import base from "../../../../../assets/icons/chains/baseNew.png";
import bnb from "../../../../../assets/coins/bnb.png";
import usdc from "../../../../../assets/coins/usdc.png";
import usdt from "../../../../../assets/icons/chains/usdt.png";
import sol from "../../../../../assets/icons/chains/sol.png";
import ton from "../../../../../assets/coins/ton.png";
import tron from "../../../../../assets/coins/tron.png";
import { shadowAndBorderClass } from "screens/Dashboard/utils/classes";

const paymentMethods = [
  [
    {
      name: "ETH",
      icon: eth,
      count: "0",
      indicators: [base, eth],
      color: "text-blue-600",
    },
    {
      name: "BNB",
      icon: bnb,
      count: "0",
      indicators: [bnb],
      color: "text-yellow-600",
    },
  ],
  [
    {
      name: "USDT",
      icon: usdt,
      count: "0",
      indicators: [eth, bnb, tron, sol, ton],
      color: "text-yellow-600",
    },
    {
      name: "USDC",
      icon: usdc,
      count: "0",
      indicators: [eth, bnb, sol, base],
      color: "text-blue-600",
    },
  ],
];

const mainIconBorder = `relative before:content-[''] before:absolute before:inset-0 before:p-px max-lg:before:p-px before:rounded-full max-lg:before:rounded-full before:[background:linear-gradient(107deg,rgba(255,255,255,1)_0%,rgba(255,255,255,0)_100%)] before:[-webkit-mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)] before:[-webkit-mask-composite:xor] before:[mask-composite:exclude] before:z-[1] before:pointer-events-none`;

export const ChainGrid = () => {
  return (
    <div className="flex-col items-start gap-[16px] max-lg:gap-[8px] w-full flex">
      {paymentMethods.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="items-start gap-[16px] max-lg:gap-[8px] w-full flex"
        >
          {row.map((method, methodIndex) => (
            <motion.div
              key={methodIndex}
              className={`flex items-center gap-[8px] max-lg:gap-[4px] pl-[8px] max-lg:pl-[8px] pr-[12px] max-lg:pr-[12px] py-[8px] max-lg:py-[8px] flex-1 rounded-[16px] max-lg:rounded-[16px] bg-[#161616] before:!rounded-[16px] max-lg:before:!rounded-[16px] ${shadowAndBorderClass}`}
              initial={{ opacity: 0, x: "-20px" }}
              animate={{ opacity: 1, x: 0 }}
              transition={{
                delay: 0.8 + (rowIndex * 2 + methodIndex) * 0.1,
                duration: 0.5,
              }}
              whileHover={{ scale: 1.02, x: "5px" }}
            >
              <div className="relative w-[32px] max-lg:w-[24px] h-[32px] max-lg:h-[24px] rounded-full">
                <div
                  className={`w-[32px] max-lg:w-[24px] h-[32px] max-lg:h-[24px] rounded-full border-none bg-cover bg-[50%_50%] ${mainIconBorder}`}
                  style={{ backgroundImage: `url(${method.icon})` }}
                />
              </div>

              <div className="flex-1 font-luxora-regular text-white text-[14px] max-lg:text-[16px] leading-[18px] max-lg:leading-[110%]">
                {method.name}
              </div>

              <div
                className="inline-flex items-center gap-[2px] max-lg:gap-[2px] p-[4px] max-lg:p-[4px] bg-[#252525] rounded-[16px] max-lg:rounded-[16px] border border-white/[0.06]"
              >
                {method.indicators.map((iconSrc, i) => (
                  <motion.div
                    key={i}
                    className="w-[16px] max-lg:w-[12px] h-[16px] max-lg:h-[12px] rounded-full bg-cover bg-[50%_50%]"
                    style={{ backgroundImage: `url(${iconSrc})` }}
                    whileHover={{ scale: 1.2 }}
                    transition={{ delay: i * 0.1 }}
                  />
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      ))}
    </div>
  );
};
